export default "__VITE_ASSET__uL0EDWXF__"